import React from "react";
import PropTypes from "prop-types";
import { useRive } from "@rive-app/react-canvas";

import "./RiveAnimation.scss";

function RiveAnimation({
  src,
  stateMachines,
  autoplay = true,
  width,
  height,
  style = {},
  className = "",
  onLoad = () => {},
  onLoadError = () => {},
  onPlay = () => {},
  onPause = () => {},
  onStop = () => {},
  layout,
  animations,
  ...other
}) {
  const riveResult =
    useRive({
      src,
      stateMachines,
      autoplay,
      onLoad: (event) => onLoad(event),
      onLoadError: (event) => onLoadError(event),
      onPlay: (event) => onPlay(event),
      onPause: (event) => onPause(event),
      onStop: (event) => onStop(event),
      layout,
      animations,
      ...other,
    }) || {};

  const { RiveComponent, rive } = riveResult;

  React.useImperativeHandle(other.ref, () => ({
    play: () => rive?.play(),
    pause: () => rive?.pause(),
    stop: () => rive?.stop(),
    reset: () => rive?.reset(),
    cleanup: () => rive?.cleanup(),
    rive,
  }));

  const containerStyle = {
    width: width || "100%",
    height: height || "100%",
    ...style,
  };

  return (
    <div className={`rive-animation-container ${className}`} style={containerStyle}>
      {RiveComponent ? <RiveComponent /> : <div>Loading animation...</div>}
    </div>
  );
}

RiveAnimation.propTypes = {
  src: PropTypes.string.isRequired,
  stateMachines: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  autoplay: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  className: PropTypes.string,
  onLoad: PropTypes.func,
  onLoadError: PropTypes.func,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onStop: PropTypes.func,
  loop: PropTypes.bool,
  layout: PropTypes.shape({
    fit: PropTypes.string,
    alignment: PropTypes.string,
  }),
  animations: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default RiveAnimation;
